<template>
  <div class="w100m">
    <div class="w100 flexVC" v-if="$store.state.isPc">
      <div class="header">
        <el-image
          class="header-img"
          :src="aboutImg"
          :fit="cover"></el-image>
        <div class="header-content flexVC">
          <img :src="logoImg" class="logo">
          <div class="marT50">趁早合作众多品牌实现互利共赢</div>
          <div class="marT10">{{content}}</div>
        </div>
      </div>
      <div class="fontS32 fontW6 C000A85">商务合作</div>
      <div class="fontS16Light C000A45 fontW3 marT10">yunfeng.cao@chenzao.com</div>
      <div class="fontS16 fontW4 C000A85 marT40">文章投稿</div>
      <div class="fontS16Light C000A45 fontW3 marT10">bing.liu@chenzao.com</div>
      <div class="fontS16 fontW4 C000A85 marT40">社群合作</div>
      <div class="fontS16Light C000A45 fontW3 marT10 ">跑团：run@chenzao.com/读书会：read@chenzao.com</div>
      <div class="fontS16 fontW4 C000A85 marT40">版权合作</div>
      <div class="fontS16Light C000A45 fontW3 marT10">ming.du@chenzao.com</div>
      <div class="fontS16 fontW4 C000A85 marT40">文创合作/企业定制</div>
      <div class="fontS16Light C000A45 fontW3 marT10">contact@chenzao.com</div>
      <div class="fontS16 fontW4 C000A85 marT40">服饰合作</div>
      <div class="fontS16Light C000A45 fontW3 marT10">chenjie@chenzao.com</div>
      <div class="fontS16 fontW4 C000A85 marT40">曾合作品牌</div>
      <div class="logo-box flexWrap marT32">
        <el-image
          v-for="item in logoBusiness"
          class="logo-img"
          :src="item"
          :fit="cover"></el-image>
        <div v-for="count in 30" class="logo-img-empty"></div>
      </div>
      <div class="C000A25 fontW3 fontS32 marT50" style="padding-bottom: 80px;"></div>
    </div>
    <!--   mobile -->
    <div class="w100 BFFF flexVC" v-if="!$store.state.isPc">
      <div class="header-m">
        <el-image
          class="header-img"
          :src="aboutImg"
          :fit="cover"></el-image>
        <div class="header-content flexVC">
          <img :src="logoImg" class="logo-m">
<!--          <div class="marT50">趁早合作众多品牌实现互利共赢</div>-->
<!--          <div class="marT10">{{content}}</div>-->
        </div>
      </div>
      <div class="fontS32m fontW6 C000A85">商务合作</div>
      <p class="fontS24m C000A45 fontW3 marT10">yunfeng.cao@chenzao.com</p>
      <div class="business-item flexHBC marT25">
        <div class="fontS28m fontW4 C000A85 ">文章投稿</div>
<!--        <div class="fontS24m fontW4 C000A45 ">文章投稿</div>-->
        <p class="fontS24m C000A45 fontW3 " style="font-weight: 600;"><span>bing.liu@chenzao.com</span></p>
      </div>
      <div class="business-item flexHBC ">
        <div class="fontS28m fontW4 C000A85 ">社群合作</div>
        <div class="fontS24m C000A45 fontW3">
          <p style="text-align: right;">跑团：run@chenzao.com</p>
          <p style="text-align: right;">读书会：read@chenzao.com</p>
        </div>
      </div>
      <div class="business-item flexHBC ">
        <div class="fontS28m fontW4 C000A85 ">版权合作</div>
        <p class="fontS24m C000A45 fontW3 ">ming.du@chenzao.com</p>
      </div>
      <div class="business-item flexHBC ">
        <div class="fontS28m fontW4 C000A85 ">文创合作/企业定制</div>
        <p class="fontS24m C000A45 fontW3 ">contact@chenzao.com</p>
      </div>
      <div class="business-item flexHBC " style="border-bottom: 1px solid rgba(0,0,0,0.06);">
        <div class="fontS28m fontW4 C000A85 ">服饰合作</div>
        <p class="fontS24m C000A45 fontW3 ">chenjie@chenzao.com</p>
      </div>
      <div class="fontS28m fontW4 C000A85 marT40">曾合作品牌</div>
      <div class="logo-box-m flexWrap marT25">
        <el-image
          v-for="item in logoBusiness"
          class="logo-img-m"
          :src="item"
          :fit="cover"></el-image>
        <div v-for="count in 30" class="logo-img-empty-m"></div>
      </div>
      <div class="C000A25 fontW3 fontS32 marT50" style="padding-bottom: 0.8rem;"></div>
    </div>
    <shape-footer></shape-footer>
  </div>

</template>

<script>
  import logoImg from '@/assets/images/icon_about_logo.png'
  import shapeFooter from '@/components/ShapeFooter'
  import {logoBusiness} from '@/utils/staticData'

  export default {
    name: "AboutBusiness",
    data() {
      return {
        cover: 'cover',
        aboutImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bussiness.png',
        logoImg: logoImg,
        content: '欢迎各大品牌合作交流，共同携手为品牌助力，见证美好的发生',
        logoBusiness: [],
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      window.scrollTo(0, 0);
      if (!this.$store.state.isPc) {
        this.$store.commit('isAlphaEdit', true)
      }
      this.$store.commit('edit', 2)
      this.logoBusiness = logoBusiness
    }

  }
</script>

<style scoped>

  .header {
    width: 100%;
    height: 600px;
    position: relative;
    margin-bottom: 80px;
  }

  .header-img {
    width: 100%;
    height: 100%;
    background: #f00;
  }

  .header-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
  }

  .logo {
    width: 128px;
    height: 128px;
  }

  .marT80 {
    margin-top: 80px;
  }

  .fontS32 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS24 {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS16 {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS16Light {
    font-size: 16px;
    font-family: PingFangSC-Light, PingFang SC;
  }

  .fontW4 {
    font-weight: 400;
  }

  .C000A85 {
    color: rgba(0, 0, 0, 0.85);
  }

  .C000A25 {
    color: rgba(0, 0, 0, 0.15);
  }

  .C000A45 {
    color: rgba(0, 0, 0, 0.45);
    /*color: #c0bfbe;*/
  }

  .fontW6 {
    font-weight: 600;
  }

  .fontW3 {
    font-weight: 200 !important;
  }

  .left-item {
    width: 496px;
  }

  .right-item {
    width: 496px;
  }

  .content {
    width: 380px;
  }


  .logo-box {
    width: 70%;
    min-width: 1000px;
  }

  .logo-img-empty {
    width: 119px;
    height: 2px;
  }

  .logo-img {
    width: 119px;
    height: 70px;
  }

  .flexVR {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }


  /* ************************mobile*************************** */
  .header-m {
    width: 100%;
    height: 4rem;
    position: relative;
    margin-bottom: 0.8rem;
  }

  .business-item{
    width: 6.54rem;
    height: 1rem;

    border-top: 1px solid rgba(0,0,0,0.06);
  }

  .logo-m {
    width: 1.24rem;
    height: 1.24rem;
  }

  .logo-box-m {
    width: 6.72rem;
  }

  .logo-img-empty-m {
    width: 1.3rem;
    height: 2px;
  }

  .logo-img-m {
    width: 1.3rem;
    height: 0.77rem;
  }

  .fontS32m {
    font-size: 0.32rem;
  }

  .fontS24m {
    font-size: 0.24rem;
    /*font-family: PingFangSC-Semibold, PingFang SC;*/
  }

  .fontS28m{
    font-size: 0.28rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .marT10m {
    margin-top: 0.1rem;
  }

  /*  ********************** f0f2f5 *******/

</style>



// WEBPACK FOOTER //
// src/page/about/AboutBusiness.vue